import Reveal from '@/components/base/Reveal';
import { readingTips } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TipsSection() {
  return (
    <section id="tips" className="scroll-mt-16 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Tips"
            title="阅读贴士：让长文读起来更顺"
            desc="无论是小说还是漫画，合适的阅读方式都能明显提升体验。下面这些整理自常见阅读问题的建议，可以帮助你少走弯路。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {readingTips.map((tip, index) => (
            <Reveal key={tip.title} delay={index * 50}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 flex flex-col gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900 text-xl">
                  <i className={tip.icon} />
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900">{tip.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}